import { SubscriptionStatus } from '../../constants/subscription';
import {
  SubscriptionDetails,
  SubscriptionShortDetails,
  UpdateSubscriptionDetailsInput,
} from '../../interfaces/subscription';

const subscriptionStatusFromServerFormat = (subscription: any): SubscriptionStatus => {
  if (subscription.paused) {
    return SubscriptionStatus.PAUSED;
  }

  if (subscription.canceledAt) {
    return SubscriptionStatus.CANCELLED;
  }

  return SubscriptionStatus.ACTIVE;
};

export const subscriptionShortDetailsFromServerFormat = ({
  totalPrice,
  subscription,
}: any): SubscriptionShortDetails => ({
  id: subscription.id,
  intervalInDays: subscription.intervalInDays,
  itemsCount: subscription.items.length,
  nextRequestAt: subscription.nextRequestAt,
  oneOffPurchaseItemsCount: subscription.oneOffPurchaseItems?.length,
  periodEndAt: subscription.periodEndAt * 1000,
  shortId: subscription.shortId,
  status: subscriptionStatusFromServerFormat(subscription),
  subscription: subscriptionDetailsFromServerFormat(subscription),
  totalPrice,
});

export const subscriptionDetailsFromServerFormat = (subscription: any): SubscriptionDetails => ({
  billingAddressId: subscription.billingAddressId,
  id: subscription.id,
  inactiveItems: subscription.inactiveItems || [],
  intervalInDays: subscription.intervalInDays,
  items: subscription.items,
  itemsCount: subscription.items.length,
  oneOffPurchaseItems: subscription.oneOffPurchaseItems,
  outOfStockItems: subscription.outOfStockItems || [],
  payment: subscription.payment,
  periodEndAt: subscription.periodEndAt * 1000,
  shipping: subscription.shipping,
  shippingAddressId: subscription.shippingAddressId,
  shopid: subscription.shopid,
  shortId: subscription.shortId,
  status: subscriptionStatusFromServerFormat(subscription),
  nextRequestAt: subscription.nextRequestAt,
});

export const subscriptionDetailsToServerFormat = (
  subscription: Partial<UpdateSubscriptionDetailsInput>
) => ({
  id: subscription.id,
  shortId: subscription.shortId,
  intervalInDays: subscription.intervalInDays,
  periodEndAt: subscription.periodEndAt && Math.floor(subscription.periodEndAt / 1000),
  items: subscription.items,
  inactiveItems: subscription.inactiveItems,
  payment: subscription.payment,
  shipping: subscription.shipping,
  shippingAddressId: subscription.shippingAddressId,
  billingAddressId: subscription.billingAddressId,
  cancel: subscription.cancel,
  canceledReason: subscription.cancelReason,
  canceledReasonText: subscription.canceledReasonText,
  paused: subscription.paused,
  pausedReason: subscription.pausedReason,
  pausedReasonText: subscription.pausedReasonText,
});
